export const SAMPLES_REQUEST_STEPS = ['Product selection', 'Shipping address', 'Order confirmation'];
export const MAX_ITEMS_REQUESTED = 2;
